<template>
  <b-modal
    centered
    :hide-footer="true"
    modal-class="c-wrap"
    dialog-class="c-dialog"
    content-class="c-content"
    header-class="popup_left_header"
    body-class="c-body container"
    :visible="visible"
    @show="onShow"
    @hide="hide"
  >
    <template #modal-header="{ close }">
      <span>{{$t('more.view_monthly_payment')}}</span>
      <b-img class="mo_close_btn"  @click="hide" :src="require('../../../assets/image/ic_close2.png')"/>
    </template>
    <div class="align-vertical">
      <div class="c-row">
        <div class="loan_caption">{{$t('more.loan_method')}}</div>
        <div class="input input_wrapper1">{{LOAN_METHOD[method]}}</div>
      </div>
      <div class="c-row">
        <div class="loan_caption">{{$t('more.loan_principal')}}</div>
        <div class="input input_wrapper1">{{principal+' '+$t('common.won')}}</div>
      </div>
      <div class="c-row">
        <div class="loan_caption">{{$t('more.loan_period')}}</div>
        <div class="input input_wrapper1">{{period+' '+u.format(this.$t('map.month'), '')}}</div>
      </div>
      <div class="c-row" style="margin-bottom: 1em;">
        <div class="loan_caption">{{$t('more.loan_interest_rate')}}</div>
        <div class="input input_wrapper1">{{rate+' %'}}</div>
      </div>

      <b-table bordered
               class="md_table"
               :items="items"
               :fields="fields">
      </b-table>
    </div>

  </b-modal>
</template>

<script>
import moment from "moment";
import Utils from "../../../config/utils";
import CSwitch from "../CSwitch";
const u = require('util');
const LOAN_METHOD = [
  '원리금균등분할상환',
  '만기일시상환',
  '원금균등분할상환',
];

export default {
  name: "MonthlyPopup",
  components:{
    CSwitch,
  },
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    method:{
      type:Number,
      default:0
    },
    principal:{
      type:String,
      default: '',
    },
    period:{
      type:String,
      default: '',
    },
    rate:{
      type:String,
      default: '',
    }
  },
  data() {
    return {
      u:u,
      LOAN_METHOD:LOAN_METHOD,
      items:[],
      fields:[
        {key: "a", label: this.$t('more.round'), thClass: "md_table_header", tdClass:"md_table_cell", thStyle:"width:12%;"},
        {key: "b", label: this.$t('more.repay_principal_rate'), thClass: "md_table_header", tdClass:"md_table_cell", thStyle:"width:22%;"},
        {key: "c", label: this.$t('more.repay_principal'), thClass: "md_table_header", tdClass:"md_table_cell", thStyle:"width:22%;"},
        {key: "d", label: this.$t('more.monthly_loan_interest'), thClass: "md_table_header", tdClass:"md_table_cell", thStyle:"width:22%;"},
        {key: "e", label: this.$t('more.loan_balance'), thClass: "md_table_header", tdClass:"md_table_cell", thStyle:"width:22%;"},
      ],


    }
  },
  methods:{
    onShow(){
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
      this.initState();
    },

    hide(){
      if(window.history.state == "forward")
        window.history.back();
    },
    initState(){
      this.items = [];
      let {method, principal, period, rate} = this;
      principal = Number(principal.replaceAll(',', ''));
      period = Number(period.replaceAll(',', ''));
      rate = Number(rate.replaceAll(',', ''));

      let monthly_pay = 0;
      let B = Number(rate / 12) / 100;

      if (method == 0) {
        let denominator = (Math.pow(1 + B, period) - 1);
        let numerator = (principal * B * Math.pow(1 + B, period));
        monthly_pay = Math.round(numerator / denominator);
      }
      if (method == 1) {
        monthly_pay = Math.round(principal * B);
      }
      if (method == 2) {
        monthly_pay = Math.round(principal / period);
      }

      let principal_total = principal;
      for (let ind = 1; ind <= period; ind++) {
        let monthly_rate = Math.round(principal_total * B);   // 월대출리자
        let monthly_principal = 0;                              // 월납입원금

        switch (method) {
          case 0:
            monthly_principal = monthly_pay - monthly_rate;
            break;
          case 1:
            monthly_principal = (ind == period) ? principal_total : 0;
            break;
          case 2:
            monthly_principal = monthly_pay;
            break;
        }

        if (method == 0) {
          this.items.push({
            a:ind,
            b:monthly_pay.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            c:monthly_principal.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            d:monthly_rate.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            e:ind == period ? 0 : (principal_total - monthly_principal).toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          });
        } else if (method == 1) {
          this.items.push({
            a: ind,
            b: ind == period ? (monthly_pay + principal).toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',') : monthly_pay.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            c: ind == period ? principal.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
            d: monthly_pay.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            e: ind == period ? 0 : principal.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          });
        } else {
          this.items.push({
            a:ind,
            b:(monthly_principal + monthly_rate).toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            c:monthly_principal.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            d:monthly_rate.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            e:ind == period ? 0 : (principal_total - monthly_principal).toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          });
        }
        principal_total -= monthly_principal;
      }
    }

  },
  mounted(){

  },
  inject: ['eventBus'],

}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/vars";
.input {
  text-align: right;
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
}
.input_wrapper1{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  height: 40px;
  border: solid 1px #bebdbd;
  border-radius: 3px;
  margin-left: 1em;
}

.input_reset_wrapper {
  background-color: #e6f0fd !important;
  width: 70px;
  height: 33px;
  margin-left: 5px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding:0;
  line-height: 0;
  border-style: none;
}
.input_reset {
  color: #0840ba;
  font-size: $fs_12;
  font-family: $korean_gd_15_r;
}
.dlg_close_btn {
  width: 18px;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.c-row{
  width: 100%;
  margin-bottom: 11px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.right_align{
  direction: rtl;
  padding-right: 2em;
}

.btn_text{
  color: white;
  font-size: $fs_14;
  font-family: $korean_gd_15_r;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/MonthlyPopup.vue